<h4 mat-dialog-title>{{data.title}}</h4>
<mat-dialog-content>
  <input type="text" matInput placeholder="Library Item Name" [(ngModel)]="libraryItemName">
</mat-dialog-content>
<mat-dialog-actions>
  <div fxFlex></div>
  <button mat-raised-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="libraryItemName.trim()===''" (click)="close()">
    Add
  </button>
</mat-dialog-actions>